import React, { useEffect } from "react";

export default function Loading({ inside }) {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  let top_value = "";
  inside
    ? (top_value = "50%")
    : (top_value = "calc(50vh - var(--top-from-nav) - var(--nav-height))");
  return (
    <>
      <div className="loader" style={{ top: `${top_value}` }}></div>
    </>
  );
}
